import mockApi from '../mock-api.json';
import mock from '../mock';

const { totalTickets, graphicTickets, datatotal } = mockApi.components.examples;


mock.onGet('/tablero/totaltickets/').reply(() => {
  return [200, totalTickets];
});

mock.onGet('/nivelservicio/dataticket/').reply(() => {
  return [200, graphicTickets];
});

mock.onGet('/tablero/datatotal/').reply(() => {
  return [200, datatotal];
});
